import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Card, CardActions, CardContent, CircularProgress, Stack, TextField, Typography } from '@mui/material';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import { AppFormLayout, AppSelect } from '@shared';

const propTypes = {
  orders: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    tracking: PropTypes.string,
  })),
  loading: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onQuery: PropTypes.func.isRequired,
  trackingIdFocus: PropTypes.string,

  handleTeamChange: PropTypes.func.isRequired,
  teamId: PropTypes.number,
  teamOptions: PropTypes.array.isRequired,
}

const defaultProps = {

}

const DispatchControlPerTrackingForm = (props) => {
  const lastOrder = props.orders[ props.orders.length - 1 ]
  return (
    <Card>
      <CardContent>

      <div className="mb8">
        <AppFormLayout>
          <AppFormLayout.Group>
            <AppSelect
              id="team"
              name="team"
              label={I18n.t("activerecord.models.team.one")}
              options={props.teamOptions}
              value={ props.teamId }
              onChange={ (value) => props.handleTeamChange(Number(value), "teamId") }
            />
          </AppFormLayout.Group>
        </AppFormLayout>
      </div>

      <div className="mb8">
        <Stack direction="row" spacing={2}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ flex: 1 }}>ID</Typography>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ flex: 1 }}>
            {I18n.t("activerecord.attributes.dispatch_order.tracking_number")}
          </Typography>
        </Stack>
        { props.orders.map( (order, index) =>
          <div key={index} className="mt4">
            <Stack direction="row" spacing={2}>
              <ScannerField
                id={ `${index}.id` }
                focusedId={ props.trackingIdFocus }
                placeholder="100"
                value={ order.id }
                onChange={ props.handleChange }
              />
              <ScannerField
                id={ `${index}.tracking` }
                focusedId={ props.trackingIdFocus }
                placeholder="CRAA00000"
                value={ order.tracking }
                onChange={ props.handleChange }
              />
            </Stack>
          </div>
        )}
      </div>
      <Button
        variant="outlined"
        color="inherit"
        disabled={ lastOrder.id == "" || props.loading }
        startIcon={<NoteAddOutlinedIcon />}
        onClick={ props.onAdd }>Agregar</Button>
      </CardContent>

      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button
          variant="contained"
          disabled={ props.loading }
          startIcon={ props.loading ? <CircularProgress size={16} color="inherit" /> : null }
          onClick={ props.onQuery }
        >
          { I18n.t("actions.generate") }
        </Button>
      </CardActions>
    </Card>
  )
};

// This form is driven by a barcode scanner: the parent advances `trackingIdFocus`
// to the next field after each scan and the input must follow. Polaris' TextField
// took a `focused` prop that did this; MUI's is a styling flag only, so the focus
// is moved imperatively instead.
const ScannerField = ({ id, focusedId, value, placeholder, onChange }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    if (focusedId === id) inputRef.current?.focus();
  }, [focusedId, id]);

  return (
    <TextField
      fullWidth
      size="small"
      id={id}
      inputRef={inputRef}
      placeholder={placeholder}
      value={value}
      onChange={ (event) => onChange(event.target.value, id) }
    />
  );
};

DispatchControlPerTrackingForm.propTypes = propTypes;
DispatchControlPerTrackingForm.defaultProps = defaultProps;

export default DispatchControlPerTrackingForm;